import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import QuestionsContainer from './components/QuestionsContainer';
import { getParamPreservePlus } from '../lib/utils';
import { QuestionAnswerContextProvider } from './components/QuestionAnswerContext';
import Spinner from '../common/Spinner';

const QuestionDetailsPage = (props) => {
    // store querystring params
    const [queryParams, setQueryParams] = useState(undefined);
    // store all categories
    const [categories, setCategories] = useState([]);
    // store loading state
    const [isLoading, setIsLoading] = useState(false);

    const searchParam = useLocation().search;
    const guestAccts =  process.env.REACT_APP_GUEST_ACCTS.split(',')
    

    // fetch and decrypt querystring params, get categories etc
    useEffect(() => {
        const api_url = process.env.REACT_APP_SERVER_URL;
        const getInitialData = async () => {
            try {
                setIsLoading(true);
                let promises = [];
                const searchParams = new URLSearchParams(searchParam);
                const getFirstParamValue = (...keys) =>
                    keys.map((key) => searchParams.get(key)).find((value) => value != null && value !== '');
                const rawConfigID = getFirstParamValue('cID', 'cId', 'cid', 'configID', 'configId');
                const rawCloneID = getFirstParamValue('cn', 'cloneID', 'cloneId');
                const rawProductID = getFirstParamValue('p', 'productID', 'productId');
                
                const payload = {
                    CustomerNo: getParamPreservePlus(searchParam, 'c'),
                    Email: getParamPreservePlus(searchParam, 'e'),
                    Currency: searchParams.get('curr'),
                    ConfigID: rawConfigID,
                    CloneID: rawCloneID,
                    ProductId: rawProductID,
                    Pricing: searchParams.get('pr'),
                    CanAddToCart: searchParams.get('a'),
                    Warehouse: searchParams.get('wh'),
                    Source: searchParams.get('src')
                };

                //decrypt query params
                promises.push(
                    axios.post(`${api_url}Product/Decrypt`, payload, {
                        headers: { 'Content-Type': 'application/json' },
                    })
                );

                // load categories
                promises.push(axios.get(`${api_url}Product/GetCategories`));

                Promise.all(promises).then((responses) => {
                    // set decrypted query params
                    const queryParamData = responses[0].data;
                    const paramsData = {
                        ...queryParamData,
                        // Normalize expected keys for downstream components
                        customerNo: queryParamData.customerNo ?? queryParamData.customerNumber ?? getParamPreservePlus(searchParam, 'c'),
                        email: queryParamData.email ?? getParamPreservePlus(searchParam, 'e'),
                        currency: queryParamData.currency ?? 'USD',
                        pricing: queryParamData.pricing ?? '1,1,1', // default 'See all pricing {MSRP,Wholesale,MyPrice}'
                        canAddToCart: queryParamData.canAddToCart?.toLowerCase() === "false" ? false : true,
                        warehouse: queryParamData.warehouse ?? getParamPreservePlus(searchParam, 'wh') ?? 'DANA1',
                        productID: queryParamData.productID ?? queryParamData.productId ?? rawProductID,
                        configID: queryParamData.configID ?? queryParamData.configId ?? queryParamData.ConfigID ?? rawConfigID ?? '',
                        cloneID: queryParamData.cloneID ?? queryParamData.cloneId ?? queryParamData.CloneID ?? rawCloneID ?? '',
                        isGuest: guestAccts.includes(queryParamData.customerNo),
                        source: queryParamData.source ?? getParamPreservePlus(searchParam, 'src') ?? ''
                    };
                    //debugger;
                    setQueryParams(paramsData);
                    // set categories
                    setCategories( responses[1].data);
                    
                    setIsLoading(false);
                });
            } catch (error) {
                console.log('error initializing the application', error);
                setIsLoading(false);
            }
        };
        getInitialData();
    }, [searchParam]);

    return (
        <>
            {isLoading && <Spinner />}
            {queryParams && (
                <QuestionAnswerContextProvider>
                    <QuestionsContainer
                        queryParams={queryParams}
                        categories={categories}
                    />
                </QuestionAnswerContextProvider>
            )}
        </>
    );
};

export default QuestionDetailsPage;
